import type { MappingPlugin, MappingServiceViewModel } from "@models/service";

export const buildMappingServiceViewModel = (
  plugin: MappingPlugin,
): MappingServiceViewModel => ({
  id: `${plugin.service}#${plugin.plugin_id}`,
  kind: plugin.service,
  pluginId: plugin.plugin_id,
  modelName: plugin.model_name,
});

/** One card per `(service, plugin)`, in a stable order. */
export const buildMappingServices = (
  plugins: MappingPlugin[],
): MappingServiceViewModel[] =>
  plugins
    .map(buildMappingServiceViewModel)
    .sort((a, b) => a.id.localeCompare(b.id));
